'use strict'
$(function () {
	$('.selectpicker').selectpicker({
		dropupAuto: false
	});
	
	if ($('.picker-dropdown').length) {
		$(document).on('mouseenter touchstart touchmove', '.picker-dropdown .dropdown-menu li', function(e) {
			var $dropdownMenu = $(this).parent();
			$dropdownMenu.find('li').removeClass('active');
			$(this).addClass('active');
		});
		
		$(document).on('mouseleave', '.picker-dropdown .dropdown-menu', function() {
			var $dropdownMenu = $(this);
			$dropdownMenu.find('li').removeClass('active');
			$dropdownMenu.find('.selected').addClass('active');
		});
    }

	window.onscroll = function () {
		const header = document.getElementById('header');
		const sticky = header.offsetTop + 50;
			if (window.pageYOffset > sticky) {
				header.classList.add("sticky");
			} else {
				header.classList.remove("sticky");
			}
	};

});


const main = {
	init() {
		this.textEditor.init();
		this.stickyInnerMenu();
		this.dropdownPasteLink();
	},

	textEditor: {
		init() {
			if (document.getElementById("editor")) {
				this.textEditorAction();
			}
		},
		performAction(command, history) {
			if (!history.back.length || history.back[history.back.length - 1] != editor.innerHTML) {
				history.back.push(editor.innerHTML);
			}
			document.execCommand(command, false, null);
			editor.focus();
		},

		wrapTextWithLink(url, history) {
			if (!history.back.length || history.back[history.back.length - 1] != editor.innerHTML) {
				history.back.push(editor.innerHTML);
			}
			const selectedText = window.getSelection().toString();

			if (selectedText) {
				const newHtml = `<a href="${url}">${selectedText}</a>`;
				const range = window.getSelection().getRangeAt(0);
				range.deleteContents();
				const fragment = range.createContextualFragment(newHtml);
				range.insertNode(fragment);
			}
			editor.focus();
		},

		textEditorAction() {
			const editor = document.getElementById('editor');
			const publishButton = document.querySelector('.comment__publish');
			const boldButton = document.getElementById('boldButton');
			const italicButton = document.getElementById('italicButton');
			const linkButton = document.getElementById("linkButton");
			const undoButton = document.getElementById('undoButton');
			const redoButton = document.getElementById('redoButton');
			const history = {
				back: [],
				forward: []
			};

			editor.addEventListener('input', () => {
				if (editor.innerText.trim() !== '') {
					publishButton.classList.add('_active');
				} else {
					publishButton.classList.remove('_active');
				}
			});
			document.querySelector('.comment__form').addEventListener('click', (e) => {
				if (!e.target.matches('.rating__star, .rating, .rating__input, .comment__publish, .btn, .comment__form-author, path, svg')) {
					editor.focus();
				}
			})

			boldButton.addEventListener('click', () => {
				this.performAction('bold', history);
			});

			italicButton.addEventListener('click', () => {
				this.performAction('italic', history);
			});

			linkButton.addEventListener("click", () => {
				const url = prompt("Введите URL для ссылки:", "https://");
				if (url) {
					this.wrapTextWithLink(url, history);
				}
			});



			undoButton.addEventListener('click', function () {
				if (!history.back.length) {
					return;
				}
				history.forward.push(editor.innerHTML);
				editor.innerHTML = history.back.pop();
				editor.focus();
			});

			redoButton.addEventListener('click', function () {
				if (!history.forward.length) {
					return;
				}
				history.back.push(editor.innerHTML);
				editor.innerHTML = history.forward.pop();
				editor.focus();
			});

			editor.addEventListener('keydown', function () {
				history.forward.length = [];
				history.back.push(editor.innerHTML);
			});


		}



	},

	findHeight() {
		const zone = document.querySelector('[data-navbar-hide-zone]');
		if (zone) {
			const height = zone.getBoundingClientRect().bottom + window.scrollY + 50;
			return height;
		}
	},

	stickyInnerMenu() {
		$(".navbar-sticky").hide();
		var navincluded = $('#navbarSticky');
		if (navincluded.length) {
			var offset = this.findHeight();
			$(window).scroll(function () {
				if ($(this).scrollTop() > offset) {
					$('.navbar-sticky').fadeIn();
				} else {
					$('.navbar-sticky').fadeOut();
				}
			});
		}
	},

	dropdownPasteLink() {
		const dropdowns = document.querySelectorAll('.selectpicker')

		dropdowns.forEach(select => {

			// ищем родителя селектпикера
			const parent = select.parentElement
			if (!parent) return;
			
			const observer = new MutationObserver(() => {
				// ищем созданный список от селектпикера
				const ul = parent.querySelector("ul.dropdown-menu");
				if(!ul) return
				
				// ищем ссылки внутри списка
				const options = select.querySelectorAll('option')
				const links = ul.querySelectorAll("li a");
				if(!links.length) return

				// ищем и подставляем ссылки тегам
				links.forEach((a, i) => {
					const option = options[i]
					const url = option?.dataset.url

					if(url) {
						a.setAttribute('href', url)
					} else {
						a.removeAttribute('href')
					}
                })

				observer.disconnect()
			})

			// наблюдение за изменениями внутри родителя
			observer.observe(parent, { childList: true, subtree: true })
		})
	}
}

main.init();